export const STATE__COMPLETE = 'STATE__COMPLETE';
export const STATE__ERROR = 'STATE__ERROR';
export const STATE__IDLE = 'STATE__IDLE';
export const STATE__LOADING = 'STATE__LOADING';
